import { useCallback } from 'react';

import { useWebsocketSubscription } from 'hooks/useWebsocketSubscription';
import { ReferralSourceImport } from 'services/api/admin/referralSourceImports';
import { REFERRAL_SOURCE_IMPORT_CHANNEL } from 'services/api/constants';

export type ReferralSourceImportChannelMessage = ReferralSourceImport;

// ActionCable subscribe params skip OliveBranch, so the key has to be the snake_case name the Rails
// channel reads.
type ReferralSourceImportChannelParams = {
  referral_source_import_id?: string;
};

type UseReferralSourceImportChannelOptions = {
  params: ReferralSourceImportChannelParams;
  onMessageReceived?: (data: ReferralSourceImportChannelMessage) => void;
};

export default function useReferralSourceImportChannel({
  params,
  onMessageReceived,
}: UseReferralSourceImportChannelOptions) {
  const handleReceived = useCallback(
    (data: ReferralSourceImportChannelMessage) => {
      onMessageReceived?.(data);
    },
    [onMessageReceived]
  );

  const { isConnected } = useWebsocketSubscription<ReferralSourceImportChannelMessage>({
    channel: REFERRAL_SOURCE_IMPORT_CHANNEL,
    params,
    onReceived: handleReceived,
    enabled: !!params.referral_source_import_id,
  });

  return {
    isSubscribed: isConnected,
  };
}
